var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`button_common${_vm.type ? _vm.type : ''} ${_vm.disabled ? 'disabled' : ''}`,attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }